<template>
  <el-dialog
      :title="!dataForm.id ? '新增' : '修改'"
      :close-on-click-modal="false"
      :visible.sync="visible">
    <el-form :model="dataForm" ref="dataForm" :rules="rules" @keyup.enter.native="dataFormSubmit()"
             label-width="110px">
      <el-form-item label="专家关联：" prop="idCard">
        <el-select v-model="dataForm.idCard" placeholder="专家关联"
                   style="display: block;margin-bottom: 10px" @change="getExpert">
          <el-option
              v-for="item in profMemberList"
              :key="item.idcard"
              :label="item.personName"
              :value="item.idcard">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  props: {
  },
  components: {
  },
  data() {
    return {
      visible: false,
      profMemberList:'',
      dataForm: {
        id:'',
        tenderProjectCode:"",
        bidSectionCode:'',
        personName:'',
        idCard:'',
        fieldCode:'',
        deviceCode:''
      },
      rules: {
        idCard: [
          {required: true, message: '关联专家不能为空', trigger: 'blur'}
        ],

      },
      dataTypeList:''
    };
  },
  methods: {
    init(id, tenderProjectCode, bidSectionCode, idCard, fieldCode, deviceCode) {

      if(idCard){
        this.dataForm.idCard = idCard;
      }else{
        this.dataForm.idCard = '';
        this.dataForm.personName = '';
      }
      this.dataForm.tenderProjectCode = tenderProjectCode;
      this.dataForm.fieldCode = fieldCode;
      this.dataForm.deviceCode = deviceCode;
      this.dataForm.id = id;
      this.visible = true;
      this.$http({
        url: '/device/listCommitteeMember?tenderProjectCode='+tenderProjectCode+'&bidSectionCode='+bidSectionCode + '&idCard=' + (idCard == undefined?'':idCard),
        method: 'get'
      }).then(({data}) => {
        if (data && data.code === '1') {
          this.profMemberList = data.data;
        }
      })
    },
    getExpert(value) {
      let obj = {};
      obj = this.profMemberList.find((item)=>{
        return item.idcard === value;
      });
      this.dataForm.idCard = obj.idcard;
      this.dataForm.personName = obj.personName;
    },
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl('/device/saveExpert'),
            method: 'post',
            data: this.dataForm
          }).then(({data}) => {
            if (data && data.code === '1') {
              this.visible = false;
              this.$emit('refreshDataList');
              this.$message({
                message: '操作成功',
                type: 'success',
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  },
};
</script>
